export default __webpack_public_path__ + "static/media/photo-1.d3881e42.jpg";